import { render, staticRenderFns } from "./OrderableItemFixtureNew.vue?vue&type=template&id=1a728ace&"
import script from "./OrderableItemFixtureNew.vue?vue&type=script&lang=ts&"
export * from "./OrderableItemFixtureNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports